import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, Clock } from 'lucide-react';

const PaymentCancelPage = () => {
  const [params] = useSearchParams();
  const registrationId = params.get('registration_id') || '';

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50/40 via-white to-secondary-50/30 py-16 px-4">
      <div className="max-w-lg mx-auto">
        <Card className="border-neutral-100 shadow-lg">
          <CardContent className="p-8 space-y-5 text-center" data-testid="payment-cancel">
            <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-neutral-100 border border-neutral-200 mx-auto">
              <XCircle className="h-7 w-7 text-neutral-500" />
            </div>
            <h1 className="font-display text-2xl md:text-3xl font-bold text-primary-900">Payment cancelled</h1>
            <div className="rounded-xl bg-secondary-50/70 border border-secondary-200 p-4 flex items-start gap-3 text-left">
              <Clock className="h-5 w-5 text-secondary-700 shrink-0 mt-0.5" />
              <div className="text-sm text-primary-900">
                Your spot is held for 15 more minutes. Complete your payment now to lock it in.
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
              <Button asChild variant="outline" className="w-full"><Link to="/events">Back to events</Link></Button>
              <Button asChild className="w-full bg-primary-800 hover:bg-primary-900 text-white">
                <Link to={`/events/summer-of-dosti-dallas-2026/rsvp${registrationId ? `?resume=${registrationId}` : ''}`}>Try again</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
